import { css } from "@emotion/css";
import { tablet, desktop } from "./breakpoints";

const buttons = {
  primary: css({
    display: "flex",
    width: 220,
    padding: "25px 10px",
    justifyContent: "center",
    alignItems: "center",
    gap: 30,
    color: "#000",
    fontFamily: "Syne",
    fontSize: 17,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    letterSpacing: 0.34,
    textTransform: "uppercase",
    borderRadius: 30,
    border: "2px solid #FF6AFF",
    background: "rgba(168, 239, 18, 0.20)",
    boxShadow: "5px 5px 0px 0px #FF6AFF",
    backdropFilter: "blur(9.399999618530273px)",
    transition: "all .4s",

    '&:hover': {
      background: '#FF6AFF',
      boxShadow: '5px 5px 0px 0px #EB3438',
      color: "#fff",

    },

    [desktop]: {
      borderRadius: 17,
    },
    [tablet]: {
      width: 176,
      padding: "22px 16px",
      fontSize: 11.988,
      letterSpacing: 0.24,
    }
  }),
  secondary: css({
    display: "flex",
    width: 220,
    padding: "25px 10px",
    justifyContent: "center",
    alignItems: "center",
    gap: 30,
    color: "#fff",
    fontFamily: "Inter",
    fontSize: 19,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    letterSpacing: 0.34,
    borderRadius: 30,
    border: '1.2px solid #0100FE',
    background: 'rgba(255, 255, 255, 0.35)',
    backdropFilter: 'blur(12.199999809265137px)',
    transition: "all .4s",

    '&:hover': {
      background: '#FF6AFF',
      color: "#fff",

    },

    [desktop]: {
      borderRadius: 17,
    },
    [tablet]: {
      width: 176,
      padding: "22px 16px",
      fontSize: 14,
      letterSpacing: 0.24,
    }
  }),
  green: css({
    border: '1.2px solid #A8ED16 !important',
  }),
  inter: css({
    fontFamily: "Inter",
    fontSize: 19,
    textTransform: "unset",

    [tablet]: {
      padding: "22px 16px",
      fontSize: 14,
      letterSpacing: 0.24,
    }
  })
};

export default buttons;
